export default __webpack_public_path__ + "static/media/stamp_5x.dc756022.gif";